import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Icon } from '#app/shared/ui/icons/Icon.js'
import { ScrollArea } from '#app/shared/ui/utils/ScrollArea.js'

const garantiaOptimaComponents = [
  'Motor',
  'Caja de cambios',
  'Sistema de lubricación',
  'Sistema de refrigeración',
  'Sistema de alimentación',
  'Sistema eléctrico esencial',
  'Sistema de dirección',
  'Sistemas de seguridad',
]

const garantiaPremiumComponents = [
  'Turbo y sistemas de sobrealimentación',
  'Válvula EGR',
  'Sistemas de anticontaminación',
  'Sistema eléctrico y electrónico avanzado',
  'Circuito de climatización',
  'Embrague y volante motor',
  'Otros componentes según condiciones del contrato',
]

const exclusiones = [
  'Elementos sujetos a mantenimiento periódico',
  'Neumáticos, frenos, carrocería y pintura',
  'Accesorios no montados de origen',
  'Reparaciones preventivas',
  'Daños derivados de uso indebido o fuerza mayor',
]

const obligaciones = [
  'Respetar los intervalos de mantenimiento establecidos por el fabricante',
  'Conservar las facturas de mantenimiento',
  'Utilizar el vehículo conforme a las recomendaciones del fabricante',
  'Comunicar cualquier incidencia antes de realizar reparaciones',
]

type Props = {
  setOpen: (val: boolean) => void
}

export default function ContadoPopUpContent({ setOpen }: Props) {
  return (
    <ScrollArea
      className={`
        fixed left-1/2 top-1/2 h-screen -translate-x-[50%] -translate-y-[50%]
        rounded-base border border-neutral-75 bg-white

        md:h-[654px] md:w-[575px]
      `}
    >
      <div className="relative">
        <Icon
          name="basic/x"
          size="24px"
          className={`fixed right-4 top-4 cursor-pointer text-neutral-300`}
          onClick={() => setOpen(false)}
        />
        <div
          className={`
            w-screen px-4 pb-14 pt-12

            md:w-[574px] md:max-w-[574px]

            xl:pl-11 xl:pr-[66px]
          `}
        >
          <p className="text-h4 text-neutral-900">
            Nuestras garantías para vehículos de ocasión
          </p>

          <Spacer size="28px" sizeMd="40px" />

          <p className="text-base-medium text-neutral-500">
            En la compra de un vehículo de ocasión, la tranquilidad es
            fundamental. Por eso ponemos a tu disposición{' '}
            <span className="font-bold">dos niveles de garantía</span>,
            diseñados para proteger tu coche frente a averías imprevistas y
            ayudarte a conducir con total confianza.
          </p>

          <Spacer size="40px" />

          {/* Garantía Óptima */}
          <div className="flex flex-col gap-4">
            <p className="text-h5-bold text-neutral-900">Garantía Óptima</p>
            <p className="text-base-bold text-neutral-900">Cobertura base</p>
            <p className="text-base-medium text-neutral-500">
              La <span className={`font-bold`}>Garantía Óptima</span> es nuestra
              garantía base para vehículos de ocasión. Ofrece protección frente
              a{' '}
              <span className={`font-bold`}>
                averías mecánicas, eléctricas y
              </span>{' '}
              electrónicas de origen interno, fortuito e imprevisto, que afecten
              al electrónicas de origen interno, fortuito e imprevisto, que
              afecten al correcto funcionamiento del vehículo.
            </p>
            <p className="text-base-bold text-neutral-900">
              ¿Qué cubre la Garantía Óptima?
            </p>
            <p className="text-base-medium text-neutral-500">
              Incluye la reparación o sustitución de los{' '}
              <span className="font-bold">principales componentes</span> del
              vehículo, entre otros:
            </p>
            <ul className="ml-6 flex list-disc flex-col gap-3">
              {garantiaOptimaComponents.map((text) => (
                <li
                  key={text}
                  className="text-subtitle1-medium text-neutral-500"
                >
                  {text}
                </li>
              ))}
            </ul>
            <p className="text-base-medium text-neutral-500">
              Una opción ideal si buscas una{' '}
              <span className={`font-bold`}>
                cobertura equilibrada y eficaz
              </span>
              , adaptada al uso normal del vehículo.
            </p>
          </div>

          <Spacer size="40px" />

          {/* Garantía Premium */}
          <div className="flex flex-col gap-4">
            <p className="text-h5-bold text-neutral-900">Garantía Premium</p>
            <p className="text-base-bold text-neutral-900">
              Cobertura ampliada
            </p>
            <p className="text-base-medium text-neutral-500">
              La <span className={`font-bold`}>Garantía Premium</span> es
              nuestra opción más completa, pensada para quienes quieren
              disfrutar de su vehículo con la{' '}
              <span className={`font-bold`}>máxima tranquilidad</span> y
              minimizar imprevistos.
            </p>
            <p className="text-base-medium text-neutral-500">
              Cubre averías{' '}
              <span className="font-bold">
                mecánicas, eléctricas y electrónicas
              </span>{' '}
              de origen interno, fortuito e imprevisto, ampliando la protección
              a un mayor número de componentes y sistemas del vehículo.
            </p>
            <p className="text-base-bold text-neutral-900">
              ¿Qué incluye la Garantía Premium?
            </p>
            <p className="text-base-medium text-neutral-500">
              Además de todo lo incluido en la Garantía Óptima, la Garantía
              Premium amplía la cobertura a otros elementos, como:
            </p>
            <ul className="ml-6 flex list-disc flex-col gap-3">
              {garantiaPremiumComponents.map((text) => (
                <li
                  key={text}
                  className="text-subtitle1-medium text-neutral-500"
                >
                  {text}
                </li>
              ))}
            </ul>
            <p className="text-base-medium text-neutral-500">
              En función de la modalidad contratada, la Garantía Premium puede
              incluir <span className="font-bold">servicios adicionales</span>,
              como vehículo de sustitución o mayores límites económicos por
              avería.
            </p>
            <p className="text-base-medium text-neutral-500">
              Es la opción recomendada si buscas una{' '}
              <span className="font-bold">protección superior</span> frente a
              reparaciones de mayor coste.
            </p>
          </div>

          <Spacer size="40px" />

          {/* Exclusiones generales */}
          <div className="flex flex-col gap-4">
            <p className="text-h5-bold text-neutral-900">
              Exclusiones generales
            </p>
            <p className="text-base-medium text-neutral-500">
              Quedan excluidas las averías derivadas del{' '}
              <span className="font-bold">uso y desgaste normal</span>, así
              como, entre otras:
            </p>
            <ul className="ml-6 flex list-disc flex-col gap-3">
              {exclusiones.map((text) => (
                <li
                  key={text}
                  className="text-subtitle1-medium text-neutral-500"
                >
                  {text}
                </li>
              ))}
            </ul>
            <p className="text-base-medium text-neutral-500">
              Las exclusiones completas se detallan en las{' '}
              <span className="font-bold">
                condiciones generales del contrato de garantía
              </span>
              .
            </p>
          </div>

          <Spacer size="40px" />

          {/* Obligaciones del titular */}
          <div className="flex flex-col gap-4">
            <p className="text-h5-bold text-neutral-900">
              Obligaciones del titular
            </p>
            <p className="text-base-medium text-neutral-500">
              Para mantener la validez de la garantía, el titular deberá:
            </p>
            <ul className="ml-6 flex list-disc flex-col gap-3">
              {obligaciones.map((text) => (
                <li
                  key={text}
                  className="text-subtitle1-medium text-neutral-500"
                >
                  {text}
                </li>
              ))}
            </ul>
          </div>

          <Spacer size="40px" />

          {/* ¿Quién puede contratar la garantía? */}
          <div className="flex flex-col gap-4">
            <p className="text-h5-bold text-neutral-900">
              ¿Quién puede contratar la garantía?
            </p>
            <p className="text-base-medium text-neutral-500">
              Estas garantías están disponibles para{' '}
              <span className="font-bold">
                personas físicas y profesionales con condición de consumidores y
                usuarios
              </span>
              , siempre que el uso y destino del vehículo se ajusten a las
              condiciones establecidas en el contrato.
            </p>
          </div>

          <Spacer size="40px" />

          {/* Información importante */}
          <div className="flex flex-col gap-4">
            <p className="text-h5-bold text-neutral-900">
              Información importante
            </p>
            <p className="text-base-medium text-neutral-500">
              Las coberturas, límites económicos, duración y condiciones
              aplicables dependerán de la{' '}
              <span className="font-bold">
                modalidad de garantía contratada
              </span>{' '}
              y quedarán reflejadas en la documentación contractual
              correspondiente.
            </p>
          </div>
        </div>
      </div>
    </ScrollArea>
  )
}
